import React from 'react';
import SetupPasswordForm from 'components/SetupPasswordForm';

function SetupPassword() {
  return <SetupPasswordForm />;
}

export default SetupPassword;
